import { BoundTextField } from "lib/@components/binding/bound-components"
import { BlockKeyboard } from "lib/@components/block-clicks"

const EMPTY_OPTIONS = []

/**
 * Options editor for a "choice" requested field.
 *
 * Bound to the field's `options` array, but edited as free text (one choice per line, or comma
 * separated) and only normalised into the cleaned array on BLUR (`transformOutOnBlur` + `changeOnBlur`).
 * Normalising on every keystroke (the previous `transformOut`) trimmed and dropped empties as you
 * typed, so a trailing space or the Enter newline was stripped the instant it was entered (Enter/Space
 * appeared to do nothing). `transformIn` therefore tolerates both the stored array and the in-progress
 * raw string. `BlockKeyboard` stops Enter bubbling to the share dialog's default action. The server
 * (`normalizeRequestedFields`) cleans the array again on save.
 */
export function RequestedFieldOptionsEditor() {
    return (
        <BlockKeyboard sx={{ width: 1 }}>
            <BoundTextField
                data-cy="requested-field-options"
                field="options"
                label="Choices"
                size="small"
                fullWidth
                multiline
                minRows={2}
                defaultValue={EMPTY_OPTIONS}
                placeholder="One per line, or comma separated"
                transformIn={optionsToText}
                transformOutOnBlur={textToOptions}
                changeOnBlur
                helperText="Enter each choice on its own line or separated by commas."
            />
        </BlockKeyboard>
    )
}

function optionsToText(options) {
    if (typeof options === "string") return options
    if (!Array.isArray(options)) return ""
    return options.join("\n")
}

function textToOptions(text) {
    if (typeof text !== "string") return []
    return text
        .split(/[\n,]/)
        .map((option) => option.trim())
        .filter((option) => option.length > 0)
}
